'use strict';

import dayjs from 'dayjs';

/** Long-form date for study builder UI and summaries (e.g. May 28, 2026). */
export function formatDisplayDate(value) {
	if (value == null || value === '') return '—';
	const d = dayjs(value);
	return d.isValid() ? d.format('MMMM D, YYYY') : String(value);
}

/** @param {string|import('dayjs').Dayjs} value */
export function formatUsDate(value) {
	return formatDisplayDate(value);
}
